import axios from 'lib/axios'

const test360SaveFinalData = async (processId: number, finalDate: string) => {
  const apiUrl = `/process/final_data_test_360`

  try {
    const response = await axios.post(apiUrl, { process_id: processId, final_date: finalDate })
    return response.data
  } catch (error) {
    console.error('error saving test 360 final date', error)
  }
}

export default test360SaveFinalData
